import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable, map, startWith} from 'rxjs';
import {PlaygroundProductType, PlaygroundLookups, PlaygroundTraveler} from '../../model/playground.model';

@Component({
  selector: 'playground-payment-dialog',
  templateUrl: './playground-payment-dialog.component.html',
  standalone: false
})
export class PlaygroundPaymentDialogComponent implements OnInit {
  @Input() salesOrderId!: number;
  @Input() productTypes: PlaygroundProductType[] = [];
  @Input() lookups: PlaygroundLookups | null = null;

  form!: FormGroup;
  filteredTravelers!: Observable<PlaygroundTraveler[]>;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PlaygroundPaymentDialogComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      travelerId: [null],
      travelerName: [''],
      productTypeId: [null],
      amount: [null],
      sourceAmount: [null],
      amountUSD: [null],
      currencyCode: ['USD'],
      invoiceTypeId: [null],
      reference: [''],
      paymentDate: [''],
      vendorReference: ['']
    });

    this.filteredTravelers = this.form.get('travelerName')!.valueChanges.pipe(
      startWith(''),
      map(value => {
        const filter = (value || '').toLowerCase();
        return (this.lookups?.travelers || []).filter(t => t.name.toLowerCase().includes(filter));
      })
    );
  }

  onTravelerSelected(name: string): void {
    const traveler = this.lookups?.travelers.find(t => t.name === name);
    this.form.patchValue({travelerId: traveler?.travelerId || null});
  }

  save(): void {
    if (this.form.valid) {
      const val = this.form.value;
      this.dialogRef.close({
        salesOrderId: this.salesOrderId,
        ...val,
        paymentDate: val.paymentDate instanceof Date ? val.paymentDate.toISOString().substring(0, 10) : val.paymentDate || null
      });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
